/* eslint-disable @typescript-eslint/no-explicit-any -- pre-existing legacy code, not touched in this pass; typing this properly is tracked separately */
import { useTranslation } from "react-i18next";
import { useStore } from "react-redux";
import { RootState } from "store";
import { IgnoreList } from "./IgnoreList";
import styles from "./IgnoreList.module.scss";
interface IgnoreListTypes {
  ignoreItems: any;
}

export const IgnoreListContainer = ({ ignoreItems }: IgnoreListTypes) => {
  const store = useStore<RootState>();
  const { t } = useTranslation();
  const message: string = `
      ${ignoreItems.length} ${ignoreItems.length > 1 ? t("items") : t("item")} failed to load - no space available.
    `;

  const groupsItems: any = [];
  store.getState().root.groups.forEach((obj: any) => groupsItems.push(...obj.items.map((item: any) => ({ ...item }))));

  const filteredItems: any = groupsItems.filter((obj: any) => ignoreItems.find((elem: any) => obj.uid === elem.uid));

  const titles: any = [t("Color"), t("Name"), t("Category"), t("Group"), t("Free"), t("Total")];

  const outputTitles: any = titles.map((title: string) => (
    <div className={styles["titleItem"]} key={title}>
      {title}
    </div>
  ));

  const mappedIgnoreItems = ignoreItems.map((obj: any) => {
    filteredItems.forEach((elem: any) => {
      if (obj.uid === elem.uid) {
        Object.keys(elem).forEach((key: string) => (key === "color" || key === "name" ? (obj[key] = elem[key]) : ""));
      }
    });
    return obj;
  });

  const values: any = mappedIgnoreItems.map((object: any, index: number) => {
    return (
      <div className={styles["tableRow"]} key={index + "_" + object.name}>
        {titles.map((title: any) => {
          if (title === "Group") {
            return store.getState().root.groups.map((item: any) => {
              if (item.uid === object.group) {
                return (
                  <div key={item.uid} className={styles["tableCell"]}>
                    {item.name}
                  </div>
                );
              } else {
                return null;
              }
            });
          } else {
            return Object.keys(object).map((key: any) => {
              if (key === title.toLowerCase()) {
                if (key === "color") {
                  return (
                    <div key={key} className={styles["tableCell"]}>
                      <div
                        style={{
                          backgroundColor: object[key],
                          width: "14px",
                          height: "14px",
                          borderRadius: "50%",
                        }}
                      />
                    </div>
                  );
                }
                return (
                  <div key={key} className={styles["tableCell"]}>
                    {object[key]}
                  </div>
                );
              } else {
                return null;
              }
            });
          }
        })}
      </div>
    );
  });

  return <IgnoreList message={message} outputTitles={outputTitles} values={values} />;
};
